import {ComponentType} from 'react';
import {SlideBoasVindas} from './SlideBoasVindas';
import {SlidePlanos} from './SlidePlanos';
import {SlideStreaming} from './SlideStreaming';
import {SlideApp} from './SlideApp';
import {SlideProps} from './tipos';

import './slides.scss';

/**
 * Slides padrão da tela de descanso, montados em HTML com o visual do site.
 * A playlist (public/totem/playlist.json) referencia cada um por "id".
 */

export type {SlideProps};

export type SlideId = 'boas-vindas' | 'planos' | 'streaming' | 'app';

export const SLIDES: Record<SlideId, { componente: ComponentType<SlideProps>; duracao: number }> = {
	'boas-vindas': {componente: SlideBoasVindas, duracao: 8},
	'planos': {componente: SlidePlanos, duracao: 14},
	'streaming': {componente: SlideStreaming, duracao: 12},
	'app': {componente: SlideApp, duracao: 12},
};

export function isSlideId(id: unknown): id is SlideId {
	return typeof id === 'string' && Object.prototype.hasOwnProperty.call(SLIDES, id);
}
